import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from "../../../utilities/Button";
import FlatIcon from "../../../utilities/FlatIcon";
import {getSocialIcon} from "../../../../utils/StringUtilities";
import styles from './styles/SourceItem.module.scss';
import RoundIcon from "../../utilities/RoundIcon";
import {sourceFlaticons, sourceTypesEnum} from "../../../../utils/SourceUtils";

export default class SourceItem extends Component {
    static propTypes = {
        image: PropTypes.node,
        attribution: PropTypes.string,
        children: PropTypes.node,
        onClick: PropTypes.func,
        className: PropTypes.string,
        isErrored: PropTypes.bool,
    };

    render() {
        const containerClassName = classNames({
            [styles.container]: true,
            [styles.containerErrored]: this.props.isErrored,
            [this.props.className]: this.props.className,
        });
        const iconClassName = classNames({
            [styles.icon]: true,
            [styles.iconErrored]: this.props.isErrored,
        });
        const arrowClassName = classNames({
            [styles.arrow]: true,
        });

        const ComponentToRender = props => {
            if (props.onClick) {
                return <Button onClick={props.onClick} className={containerClassName}>{props.children}</Button>
            }

            return <div className={containerClassName}>{props.children}</div>
        };

        return (
            <ComponentToRender onClick={this.props.onClick}>
                <span title={`Content source is ${this.props.isErrored ? "broken" : "healthy"}`} style={{
                    color: this.props.isErrored ? "red" : "green",
                    position: "absolute",
                    right: "6%",
                    fontSize: "2rem"
                }} role={"img"}>{this.props.isErrored ? <FlatIcon className={iconClassName} name={sourceFlaticons[sourceTypesEnum.ERROR]}/> : <>&#8226;</>}</span>
                <RoundIcon platform={this.props.attribution}>
                    <FlatIcon name={getSocialIcon(this.props.attribution)}/>
                </RoundIcon>
                {this.props.children}
                {this.props.onClick && <FlatIcon className={arrowClassName} name='flaticon-next-1'/>}
            </ComponentToRender>
        )
    }
}
